import React from 'react';
import {
  CheckCircleIcon,
} from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

/**
 * Full-screen success screen after queuing generation.
 * Extracted verbatim from pages/Articles/CreateArticle.js.
 */
export default function GenerationSuccessOverlay({
  articleType,
  numberOfArticles,
  onCreateAnother,
  goToArticles,
}) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md mx-auto text-center">
        {/* Success Icon */}
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
          <CheckCircleIcon className="h-8 w-8 text-green-600" />
        </div>

        {/* Success Message */}
        <h2 className="text-4xl font-medium text-gray-900 mb-4">
          {articleType === 'bulk'
            ? t('articles.create.success.title.bulk', { count: numberOfArticles })
            : t('articles.create.success.title.single')
          }
        </h2>
        <p className="text-gray-600 mb-8 text-lg">
          {articleType === 'bulk'
            ? t('articles.create.success.description.bulk', { count: numberOfArticles })
            : t('articles.create.success.description.single')
          }
        </p>

        {/* Action Buttons */}
        <div className="space-y-3 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center">

          <button
            onClick={onCreateAnother}
            className="btn btn-primary btn-md"
          >
            {t('articles.create.success.actions.createAnother')}
          </button>

          <button
            onClick={goToArticles}
            className="btn btn-secondary btn-md"
          >
            {t('articles.create.success.actions.myArticles')}
          </button>
        </div>

      </div>
    </div>
  );
}
